// extracted by mini-css-extract-plugin
export default {"subtitle-icon":"_3KPgU","subtitleIcon":"_3KPgU","subtitle-text":"_2SQXH","subtitleText":"_2SQXH","default-text":"_3G5kw","defaultText":"_3G5kw"};